export const PortalPaths = {
	root: 'portal',
	dashboard: {
		path: 'dashboard',
	},
	cashOperations: {
		path: 'cash-operations',
		children: {
			deposit: {
				path: 'deposit',
				children: {
					add: {
						path: 'add',
					},
					confirm: {
						path: 'confirm',
					},
				},
			},
			withdrawals: {
				path: 'withdrawals',
				children: {
					add: {
						path: 'add',
					},
					confirm: {
						path: 'confirm',
					},
				},
			},
			adjustments: {
				path: 'adjustments',
			},
			transfers: {
				path: 'transfers',
				children: {
					add: {
						path: 'add',
					}
				},
			},
			currencyExchange: {
				path: 'currency-exchange',
				children: {
					add: {
						path: 'add',
					},
					confirm: {
						path: 'confirm',
					},
				},
			},
		},
	},
	ordersExecutions: {
		path: 'orders-executions',
		children: {
			orders: {
				path: 'orders',
				children: {
					add: {
						path: 'add',
					},
					confirm: {
						path: 'confirm',
					},
				},
			},
			executions: {
				path: 'executions',
			},
		},
	},
	profile: {
		path: 'profile',
		children: {
			profileDetails: {
				path: 'profile-details',
			},
			profileDocuments: {
				path: 'profile-documents',
				children: {
					verification: {
						path: 'verification',
					},
					other: {
						path: 'other',
					},
					documentsLibrary: {
						path: 'documents-library',
					},
				},
			},
			profileBankAccounts: {
				path: 'profile-bank-accounts',
			},
			profileCorporateDetails: {
				path: 'profile-corporate-details',
			},
			profileStatements: {
				path: 'profile-statements',
			},
		},
	},
	statements: {
		path: 'statements',
	},
	product: {
		path: 'product',
	},
	products: {
		path: 'products',
	},
	portfolio: {
		path: 'my-portfolio',
	},
	inbox: {
		path: 'inbox',
	},
	order: {
		path: 'order',
	},
};
